module.exports = __webpack_public_path__ + "media/images/user-pic-fa399866d5b9db832946dfbc681a3359.svg";